import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pa-2 ma-2 flex",
  id: "layers"
}
const _hoisted_2 = { class: "headline" }
const _hoisted_3 = { class: "headline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_JsonEditorVue = _resolveComponent("JsonEditorVue")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      width: "100%",
      "max-width": "100vw"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
          default: _withCtx(() => [
            _cache[27] || (_cache[27] = _createTextVNode("Layers", -1)),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_text_field, {
              class: "pa-0 ma-1",
              modelValue: $data.search,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.search) = $event)),
              "append-icon": "mdi-magnify",
              label: "Search",
              "single-line": "",
              "hide-details": "",
              style: {"max-width":"300px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (!_ctx.projectId || _ctx.projectId === 0)
          ? (_openBlock(), _createBlock(_component_v_card_subtitle, { key: 0 }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                _createTextVNode(" Select a project to continue...", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.projectId || _ctx.projectId > 0)
          ? (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  headers: $data.headers,
                  "show-group-by": "",
                  items: $options.enhancedProjectLayers,
                  "item-key": "id",
                  search: $data.search,
                  loading: $options.loading,
                  "show-expand": "",
                  "loading-text": "Loading... Please wait",
                  "footer-props": {"items-per-page-options":[25,50,100,-1]},
                  "items-per-page": 25
                }, {
                  "item.ignore": _withCtx(({ item }) => [
                    _createVNode(_component_v_checkbox, {
                      modelValue: item.ignore,
                      "onUpdate:modelValue": ($event: any) => ((item.ignore) = $event),
                      disabled: "",
                      dense: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  "item.showByDefault": _withCtx(({ item }) => [
                    _createVNode(_component_v_checkbox, {
                      modelValue: item.showByDefault,
                      "onUpdate:modelValue": ($event: any) => ((item.showByDefault) = $event),
                      disabled: "",
                      dense: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  "item.lastModified": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(new Date(item.lastModified).toLocaleString()), 1)
                  ]),
                  top: _withCtx(() => [
                    _createVNode(_component_v_toolbar, { flat: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { class: "align-center no-gutters" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "auto" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_spacer)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "auto" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  class: "mr-2",
                                  color: "green",
                                  onClick: $options.openUploadDialog,
                                  disabled: !_ctx.projectId,
                                  small: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      left: "",
                                      small: ""
                                    }, {
                                      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                        _createTextVNode("mdi-upload", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[30] || (_cache[30] = _createTextVNode("Upload", -1))
                                  ]),
                                  _: 1
                                }, 8, ["onClick", "disabled"]),
                                _createVNode(_component_v_btn, {
                                  class: "mr-2",
                                  color: "orange",
                                  onClick: $options.openGroupManagementDialog,
                                  small: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      left: "",
                                      small: ""
                                    }, {
                                      default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                        _createTextVNode("mdi-folder-multiple", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[32] || (_cache[32] = _createTextVNode("Manage Groups", -1))
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_v_btn, {
                                  color: "primary",
                                  onClick: $options.openCreateDialog,
                                  disabled: !_ctx.projectId,
                                  small: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      left: "",
                                      small: ""
                                    }, {
                                      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                        _createTextVNode("mdi-plus-circle", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[34] || (_cache[34] = _createTextVNode("Create", -1))
                                  ]),
                                  _: 1
                                }, 8, ["onClick", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  "item.actions": _withCtx(({ item }) => [
                    _createVNode(_component_v_icon, {
                      class: "mr-2",
                      small: "",
                      onClick: ($event: any) => ($options.editItem(item))
                    }, {
                      default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                        _createTextVNode("mdi-pencil", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_icon, {
                      small: "",
                      onClick: ($event: any) => ($options.deleteItem(item))
                    }, {
                      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                        _createTextVNode("mdi-delete", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["headers", "items", "search", "loading"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_dialog, {
          persistent: "",
          modelValue: $data.dialog,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($data.dialog) = $event)),
          "max-width": "850px"
        }, {
          default: _withCtx(() => [
            ($data.dialog)
              ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, _toDisplayString($options.formTitle), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, {
                          modelValue: $data.isFormValid,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.isFormValid) = $event)),
                          ref: "createForm"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_container, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      class: "pt-0 pb-0",
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: $data.editedItem.name,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.editedItem.name) = $event)),
                                          dense: "",
                                          label: "Name",
                                          rules: [$data.rules.required]
                                        }, null, 8, ["modelValue", "rules"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      class: "pt-0 pb-0",
                                      cols: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_checkbox, {
                                          label: "Hide",
                                          dense: "",
                                          modelValue: $data.editedItem.ignore,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.editedItem.ignore) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      class: "pt-0 pb-0",
                                      cols: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_checkbox, {
                                          label: "Show By Default",
                                          dense: "",
                                          modelValue: $data.editedItem.showByDefault,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.editedItem.showByDefault) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      class: "pt-0 pb-0",
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: $data.editedItem.comments,
                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.editedItem.comments) = $event)),
                                          dense: "",
                                          label: "Comments"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      class: "pt-0 pb-0",
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select, {
                                          modelValue: $data.editedItem.vendorId,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.editedItem.vendorId) = $event)),
                                          items: $options.vendorOptions,
                                          "item-title": "name",
                                          "item-value": "id",
                                          label: "Group Assignment",
                                          dense: "",
                                          clearable: "",
                                          hint: "Select a group for this layer",
                                          "persistent-hint": ""
                                        }, null, 8, ["modelValue", "items"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      class: "ma-0 pa-0",
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_tabs, {
                                          class: "ma-0 pa-0 pl-3",
                                          modelValue: $data.selectedTab,
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.selectedTab) = $event))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_tab, null, {
                                              default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                                _createTextVNode("Source", -1)
                                              ]))]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_tab, null, {
                                              default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                                _createTextVNode("Rendering Layer", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        ($data.selectedTab === 0)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                                      _createTextVNode("Source data in GeoJSON format. Mapview only supports Mercator projection. Ensure coordinates are in Latitude and Longitude.", -1)
                                                    ]))]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_JsonEditorVue, {
                                                        modelValue: $data.editedItem.source,
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.editedItem.source) = $event)),
                                                        options: $data.options,
                                                        height: "300px"
                                                      }, null, 8, ["modelValue", "options"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        ($data.selectedTab === 1)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "8" }, {
                                                    default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                                      _createTextVNode("An array of MapboxGL rendering layers to be applied to the Source. Do not include id or source as these are dynamically applied.", -1)
                                                    ]))]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, { cols: "4" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_select, {
                                                        dense: "",
                                                        placeholder: "Add Example",
                                                        modelValue: $data.exampleLayer,
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($data.exampleLayer) = $event)),
                                                        items: $data.exampleLayers,
                                                        "item-text": 'name',
                                                        "item-value": 'value'
                                                      }, null, 8, ["modelValue", "items"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_JsonEditorVue, {
                                                        modelValue: $data.editedItem.layers,
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($data.editedItem.layers) = $event)),
                                                        options: $data.options,
                                                        height: "300px"
                                                      }, null, 8, ["modelValue", "options"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, { "hide-details": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "blue darken-1",
                          text: "",
                          onClick: $options.close
                        }, {
                          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                            _createTextVNode("Cancel", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          color: "blue darken-1",
                          text: "",
                          onClick: $options.save,
                          disabled: !$data.isFormValid
                        }, {
                          default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                            _createTextVNode("Save", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          persistent: "",
          modelValue: $data.uploadDialog,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($data.uploadDialog) = $event)),
          "max-width": "650px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _cache[45] || (_cache[45] = _createElementVNode("span", { class: "headline" }, "Upload Geographic File", -1)),
                    _createVNode(_component_v_spacer),
                    ($options.libraryStatus.GeoTIFF)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          color: "green",
                          small: "",
                          outlined: ""
                        }, {
                          default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                            _createTextVNode("GeoTIFF Ready", -1)
                          ]))]),
                          _: 1
                        }))
                      : ($options.libraryStatus.JSZip && $options.libraryStatus.toGeoJSON)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 1,
                            color: "orange",
                            small: "",
                            outlined: ""
                          }, {
                            default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                              _createTextVNode("Vector Only", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_form, {
                      modelValue: $data.isUploadFormValid,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($data.isUploadFormValid) = $event)),
                      ref: "uploadForm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_container, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_file_input, {
                                      modelValue: $data.selectedFile,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($data.selectedFile) = $event)),
                                      label: "Select geographic file",
                                      accept: $options.supportedFileTypes.join(','),
                                      rules: [$data.rules.required, $data.rules.fileType],
                                      "show-size": "",
                                      "prepend-icon": "mdi-file-upload",
                                      hint: `Supported: ${$options.supportedFileTypes.join(', ')} (Only Zipped ESRI Shapefiles are Supported)`,
                                      "persistent-hint": ""
                                    }, null, 8, ["modelValue", "accept", "rules", "hint"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            ($data.selectedFile && $options.isGeoTiffFile)
                              ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_alert, {
                                          class: "mb-3",
                                          type: "info",
                                          dense: "",
                                          text: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              left: "",
                                              small: ""
                                            }, {
                                              default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                                                _createTextVNode("mdi-terrain", -1)
                                              ]))]),
                                              _: 1
                                            }),
                                            _createTextVNode("This GeoTIFF will be processed as " + _toDisplayString($options.isHillshadeFile ? 'hillshade overlay' : 'elevation data') + ".", 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_radio_group, {
                                          modelValue: $data.geoTiffProcessingMode,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($data.geoTiffProcessingMode) = $event)),
                                          label: "Processing Mode:",
                                          dense: "",
                                          row: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_radio, {
                                              label: "Simple Bounds",
                                              value: "bounds",
                                              disabled: $data.uploading
                                            }, {
                                              label: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("strong", null, "Simple Bounds"),
                                                  _createElementVNode("div", { style: {"font-size":"12px","color":"#666"} }, "Fast, shows coverage area only")
                                                ], -1)
                                              ]))]),
                                              _: 1
                                            }, 8, ["disabled"]),
                                            _createVNode(_component_v_radio, {
                                              label: "Elevation Grid",
                                              value: "grid",
                                              disabled: $data.uploading
                                            }, {
                                              label: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("strong", null, "Elevation Grid"),
                                                  _createElementVNode("div", { style: {"font-size":"12px","color":"#666"} }, "Detailed points (works best with smaller files < 2000x2000 pixels)")
                                                ], -1)
                                              ]))]),
                                              _: 1
                                            }, 8, ["disabled"])
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: $data.uploadItem.name,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($data.uploadItem.name) = $event)),
                                      label: "Layer Name",
                                      rules: [$data.rules.required],
                                      dense: "",
                                      hint: "Auto-filled from filename"
                                    }, null, 8, ["modelValue", "rules"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: $data.uploadItem.comments,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($data.uploadItem.comments) = $event)),
                                      label: "Comments",
                                      dense: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_checkbox, {
                                      modelValue: $data.uploadItem.showByDefault,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($data.uploadItem.showByDefault) = $event)),
                                      label: "Show By Default",
                                      dense: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "6" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_checkbox, {
                                      modelValue: $data.uploadItem.ignore,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($data.uploadItem.ignore) = $event)),
                                      label: "Hide",
                                      dense: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            ($data.uploading || $data.uploadProgress > 0)
                              ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_progress_linear, {
                                          value: $data.uploadProgress,
                                          color: "primary",
                                          height: "20",
                                          striped: ""
                                        }, {
                                          default: _withCtx(({ value }) => [
                                            _createElementVNode("strong", null, _toDisplayString(Math.ceil(value)) + "%", 1)
                                          ]),
                                          _: 1
                                        }, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            ($data.uploadStatus || $data.uploadError)
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 2,
                                  class: "mt-2",
                                  type: $data.uploadError ? 'error' : 'info',
                                  dense: "",
                                  text: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($data.uploadError || $data.uploadStatus), 1)
                                  ]),
                                  _: 1
                                }, 8, ["type"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { "hide-details": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "blue darken-1",
                      text: "",
                      onClick: $options.closeUpload,
                      disabled: $data.uploading
                    }, {
                      default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                        _createTextVNode("Cancel", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "disabled"]),
                    _createVNode(_component_v_btn, {
                      color: "blue darken-1",
                      text: "",
                      onClick: $options.uploadFile,
                      disabled: !$data.isUploadFormValid || $data.uploading || !$data.selectedFile
                    }, {
                      default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                        _createTextVNode("Upload", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          persistent: "",
          modelValue: $data.dialogDelete,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($data.dialogDelete) = $event)),
          "max-width": "500px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "headline" }, {
                  default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                    _createTextVNode("Confirm Project Layer Deletion", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Are you sure you want to delete project layer '" + _toDisplayString($data.editedItem.name) + "'?", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "blue darken-1",
                      text: "",
                      onClick: $options.closeDelete
                    }, {
                      default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                        _createTextVNode("Cancel", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      color: "blue darken-1",
                      text: "",
                      onClick: $options.deleteItemConfirm
                    }, {
                      default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                        _createTextVNode("OK", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          persistent: "",
          modelValue: $data.groupManagementDialog,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($data.groupManagementDialog) = $event)),
          "max-width": "800px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _cache[56] || (_cache[56] = _createElementVNode("span", { class: "headline" }, "Manage Groups", -1)),
                    _createVNode(_component_v_spacer),
                    (_ctx.projectId && _ctx.projectId > 0)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          color: "primary",
                          small: "",
                          outlined: ""
                        }, {
                          default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                            _createTextVNode(" Current Project", -1)
                          ]))]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_chip, {
                          key: 1,
                          color: "grey",
                          small: "",
                          outlined: ""
                        }, {
                          default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                            _createTextVNode(" All Projects", -1)
                          ]))]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                (_ctx.projectId && _ctx.projectId > 0)
                  ? (_openBlock(), _createBlock(_component_v_card_subtitle, { key: 0 }, {
                      default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                        _createTextVNode("Showing groups for the current project and global groups", -1)
                      ]))]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_card_subtitle, { key: 1 }, {
                      default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                        _createTextVNode("Showing all groups across all projects", -1)
                      ]))]),
                      _: 1
                    })),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_data_table, {
                      class: "elevation-1",
                      headers: $data.groupHeaders,
                      items: $options.filteredVendors,
                      "item-key": "id",
                      loading: $options.loading,
                      "loading-text": "Loading groups..."
                    }, {
                      top: _withCtx(() => [
                        _createVNode(_component_v_toolbar, { flat: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_btn, {
                              color: "primary",
                              onClick: $options.openGroupDialog
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { left: "" }, {
                                  default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                                    _createTextVNode("mdi-plus", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[60] || (_cache[60] = _createTextVNode("Add Group", -1))
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      "item.actions": _withCtx(({ item }) => [
                        _createVNode(_component_v_icon, {
                          class: "mr-2",
                          small: "",
                          onClick: ($event: any) => ($options.editGroup(item))
                        }, {
                          default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                            _createTextVNode("mdi-pencil", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_v_icon, {
                          small: "",
                          onClick: ($event: any) => ($options.deleteGroup(item))
                        }, {
                          default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                            _createTextVNode("mdi-delete", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["headers", "items", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "blue darken-1",
                      text: "",
                      onClick: $options.closeGroupManagement
                    }, {
                      default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                        _createTextVNode("Close", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          persistent: "",
          modelValue: $data.groupDialog,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($data.groupDialog) = $event)),
          "max-width": "500px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString($options.groupFormTitle), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_form, {
                      modelValue: $data.isGroupFormValid,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($data.isGroupFormValid) = $event)),
                      ref: "groupForm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_container, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: $data.editedGroup.name,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($data.editedGroup.name) = $event)),
                                      label: "Group Name",
                                      rules: [$data.rules.required],
                                      dense: ""
                                    }, null, 8, ["modelValue", "rules"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: $data.editedGroup.description,
                                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($data.editedGroup.description) = $event)),
                                      label: "Description",
                                      dense: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "blue darken-1",
                      text: "",
                      onClick: $options.closeGroupDialog
                    }, {
                      default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                        _createTextVNode("Cancel", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      color: "blue darken-1",
                      text: "",
                      onClick: $options.saveGroup,
                      disabled: !$data.isGroupFormValid
                    }, {
                      default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                        _createTextVNode("Save", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          persistent: "",
          modelValue: $data.groupDialogDelete,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($data.groupDialogDelete) = $event)),
          "max-width": "500px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "headline" }, {
                  default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                    _createTextVNode("Confirm Group Deletion", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Are you sure you want to delete group '" + _toDisplayString($data.editedGroup.name) + "'?", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "blue darken-1",
                      text: "",
                      onClick: $options.closeGroupDelete
                    }, {
                      default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                        _createTextVNode("Cancel", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      color: "blue darken-1",
                      text: "",
                      onClick: $options.deleteGroupConfirm
                    }, {
                      default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                        _createTextVNode("OK", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}